module.exports = __webpack_public_path__ + "static/img/preview-02.058ec1e1.webp";